module.exports = __webpack_public_path__ + "img/alambre.0f1b374b.jpg";